export const environment = {
    production: false,
    hmr: false,
    self: 'selfDev',
    client: 'http://localhost:4200',
    //    host: 'https://dev.auroraonline.io:8443',
    host: 'https://rbaas.auroraonline.io:8443',
    // host: 'http://47.129.201.118:8080',
    googleAnalyticsConfig: {
        trackingId: 'AW-745794783',
        trackPageviews: true,
    },

   
};
